import React from 'react';
import LogoImg from '../../../assets/dummy/cards/puzzle.png'
import OKIcon from '../../../assets/icons/ok.svg';
import Icon from '../icon';

import { useTranslation } from 'react-i18next';

function SearchSuggestion({ products, isSearch, onClick, searchText }) {
  const { t: trans } = useTranslation();
  return (
    <>
      {isSearch &&

        <div className="search-suggestions">
          <ul>
            {products.length ? products.map(product => {
              return <li key={product.id} onClick={onClick.bind(null, product.id)}>
                <figure style={{ backgroundColor: product.iconBackgroundColor ? product.iconBackgroundColor : '#fff' }}>
                  <img src={product.iconReference ? product.iconReference : LogoImg} alt='product-logo' />
                </figure>
                <div className="details">
                  <header>
                    <h3>
                      {product.label} <span>(
                        {product.price === 0 ?
                          `${trans('detail.purchase.free')} - ${trans('result.per-company')}`
                          : `${product.price}kr ${trans('result.per-company')}`}

                        )</span>
                    </h3>
                    {
                      product._isBought && <Icon icon={OKIcon} classes="xs" />
                    }

                  </header>
                  <section>
                    <p>{product.description}</p>
                  </section>
                </div>
              </li>
            }) :
          <li><p>{trans('search.search-not-found')}</p></li>}
          </ul>
          {
            products.length > 5 &&
            <div className="see-all">
              <a href="/">see all</a>
            </div>
          }
        </div>
      }
    </>
  );
}

export default SearchSuggestion;